<template>
  <div class="dev-pdf-downloader">
    <div class="row">
      <app-button
        :disabled="downloadingPdf"
        class="btn-pdf-download"
        @click="downloadPdf"
      >
        {{ downloadingPdf ? 'Downloading PDF..' : 'Download PDF' }}
      </app-button>
    </div>
    <div class="row mt-2">
      <app-button
        :disabled="downloadingHtml"
        class="btn-pdf-download"
        @click="downloadHtml"
      >
        {{ downloadingHtml ? 'Downloading HTML..' : 'Download HTML' }}
      </app-button>
    </div>
  </div>
</template>
<script>
import PdfGeneratorMixin from '@/mixins/PdfGeneratorMixin';
import AppButton from '@/components/common/AppButton';
import DevComponentContainer from '@/components/DevComponent/DevComponentContainer';

export default {
  name: 'DevPdfDownloader',
  components: {
    AppButton,
  },
  extends: DevComponentContainer,
  mixins: [
    PdfGeneratorMixin,
  ],
  data() {
    return {
      downloadingPdf: false,
      downloadingHtml: false,
    };
  },
  methods: {
    downloadPdf() {
      this.downloadingPdf = true;

      this.downloadPdfFromBody()
        .then(() => {
          this.downloadingPdf = false;

          this.$snackbar.add({
            type: 'success',
            text: 'Successfully generated PDF from body',
          });
        })
        .catch((error) => {
          this.downloadingPdf = false;

          this.$snackbar.add({
            type: 'error',
            text: error,
          });
        });
    },
    downloadHtml() {
      this.downloadingHtml = true;

      this.downloadHtmlFromBody()
        .then(() => {
          this.downloadingHtml = false;

          this.$snackbar.add({
            type: 'success',
            text: 'Successfully generated HTML from body',
          });
        })
        .catch((error) => {
          this.downloadingHtml = false;

          this.$snackbar.add({
            type: 'error',
            text: error,
          });
        });
    },
  },
};
</script>
